/*
 * Headroom
 *
 * Calling the Headroom.js object
 */
/* eslint-disable */
var Headroom = require('headroom.js');

function headRoom() {

    // grab an element
    var header = document.querySelector("#header");
    var btn_page = ".c-button-page";
    let activeClass = 'c-button-page--active';

    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(header, {
        offset: 40,
        tolerance: {
            up: 15,
            down: 25,
        },
        classes: {
            // when element is initialised
            initial: "l-headroom",
            // when scrolling up
            pinned: "l-headroom--pinned",
            // when scrolling down
            unpinned: "l-headroom--unpinned",
            // when above offset
            top: "l-headroom--top",
            // when below offset
            notTop: "l-headroom--not-top",
            // when at bottom of scoll area
            bottom: "l-headroom--bottom",
            // when not at bottom of scroll area
            notBottom: "l-headroom--not-bottom",
        },
        onNotTop: function () {
            $(btn_page).addClass(activeClass);
        },
        onTop: function () {
            $(btn_page).removeClass(activeClass);
        }
    });

    // initialise
    headroom.init();
}


export default headRoom;
